import { render, staticRenderFns } from "./func-card.vue?vue&type=template&id=bbee7002&scoped=true"
import script from "./func-card.vue?vue&type=script&lang=js"
export * from "./func-card.vue?vue&type=script&lang=js"
import style0 from "./func-card.vue?vue&type=style&index=0&id=bbee7002&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbee7002",
  null
  
)

export default component.exports